import React from "react";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextareaAutosize,
  Stack,
  TextField,
} from "@mui/material";
import { dummyRows, dummyLogs } from "./ContentComponent/DummyData";
import UpdateIcon from "@mui/icons-material/Update";
import LogsIconDesign from "../../common/LogsIconDesign";
import UpdateIconQMS from "../../common/UpdateIconQMS"; // Import the UpdateIconQMS component
//
export default function ContextTable({
  logs = dummyLogs, // Default to dummyLogs if logs prop is not provided
  showLogs,
  onShowLogs,
  onCloseLogs,
}) {
  const rows = dummyRows; // Use dummyRows for table rows

  console.log(rows); // Debug: Log rows to verify data

  return (
    <Box mb={2}>
      <Stack direction="row" justifyContent="space-between" spacing={0} mb={1}>
        <Typography variant="h6" fontWeight="bold" sx={{ color: "#4F46E5" }}>
          Context of the Organization
        </Typography>
        <Stack direction="row" spacing={1}>
          <UpdateIconQMS
            sx={{
              minWidth: 80,
              height: 36,
              px: 2,
              py: 0.5,
            }}
            icon={<UpdateIcon />}
          />
          <LogsIconDesign
            size="small"
            variant="contained"
            sx={{ minWidth: 80, height: 36, px: 2, py: 0.5 }}
          ></LogsIconDesign>
        </Stack>
      </Stack>

      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead sx={{ backgroundColor: "#5A5A5A" }}>
            <TableRow>
              {[
                "SWOT",
                "PESTLE",
                "Internal Issues",
                "External Issues",
                "Business Strategy",
                "Competitor Analysis",
              ].map((head) => (
                <TableCell
                  key={head}
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  {head}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows
              .filter((row) => !(row.swot === "" && row.pestle === "")) // Filter out empty rows
              .map((row, idx) => (
                <TableRow key={idx}>
                  <TableCell align="center" sx={{ width: 150 }}>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Typography>{row.swot}</Typography>
                      <TextareaAutosize
                        minRows={1}
                        placeholder="Enter text"
                        defaultValue={row.swot} // Display dummy data
                        style={{
                          width: "100%",
                          padding: 3,
                          fontSize: 14,
                          borderRadius: 4,
                          border: "1px solid #ccc",
                        }}
                      />
                    </Stack>
                  </TableCell>

                  <TableCell align="center" sx={{ width: 150 }}>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Typography>{row.pestle}</Typography>
                      <TextareaAutosize
                        minRows={1}
                        placeholder="Enter text"
                        defaultValue={row.pestle} // Display dummy data
                        style={{
                          width: "100%",
                          padding: 6,
                          fontSize: 14,
                          borderRadius: 4,
                          border: "1px solid #ccc",
                        }}
                      />
                    </Stack>
                  </TableCell>

                  <TableCell>
                    <TextareaAutosize
                      minRows={1}
                      placeholder="Enter text"
                      defaultValue={row.internalIssues} // Display dummy data
                      style={{
                        width: "100%",
                        padding: 6,
                        fontSize: 14,
                        borderRadius: 4,
                        border: "1px solid #ccc",
                      }}
                    />
                  </TableCell>

                  <TableCell>
                    <TextareaAutosize
                      minRows={1}
                      placeholder="Enter text"
                      defaultValue={row.externalIssues} // Display dummy data
                      style={{
                        width: "100%",
                        padding: 6,
                        fontSize: 14,
                        borderRadius: 4,
                        border: "1px solid #ccc",
                      }}
                    />
                  </TableCell>

                  <TableCell>
                    <TextareaAutosize
                      minRows={1}
                      placeholder="Enter text"
                      defaultValue={row.businessStrategy} // Display dummy data
                      style={{
                        width: "100%",
                        padding: 6,
                        fontSize: 14,
                        borderRadius: 4,
                        border: "1px solid #ccc",
                      }}
                    />
                  </TableCell>

                  <TableCell>
                    <TextareaAutosize
                      minRows={1}
                      placeholder="Enter text"
                      defaultValue={row.competitorAnalysis} // Display dummy data
                      style={{
                        width: "100%",
                        padding: 6,
                        fontSize: 14,
                        borderRadius: 4,
                        border: "1px solid #ccc",
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Logs Dialog */}
      <Dialog open={showLogs} onClose={onCloseLogs} maxWidth="md" fullWidth>
        <DialogTitle fontWeight="bold">
          Context of the Organization - Logs
        </DialogTitle>
        <DialogContent dividers>
          <Table size="small">
            <TableHead sx={{ backgroundColor: "#1976d2" }}>
              <TableRow>
                {["Date", "User", "Action"].map((head) => (
                  <TableCell
                    key={head}
                    sx={{ color: "white", fontWeight: "bold" }}
                  >
                    {head}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {logs.length > 0 ? (
                logs.map((log, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{log.date}</TableCell>
                    <TableCell>{log.user}</TableCell>
                    <TableCell>{log.action}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    No logs available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCloseLogs} variant="contained" color="error">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
